import useViewModel from "./viewModel";
import View from "./view";

const ResetPassword = () => {
  const viewModel = useViewModel();

  return <View {...viewModel} />;
};

export default ResetPassword;
